import { DeterministicView } from '@bingads-webui/deterministic-view';
import pagedContentTemplate from '../template/contents/paged.pug';
import { PagerView } from './pager';

/** The View class of paged content */
export class PagedContent extends DeterministicView {
  /**
   *
   * @param {object} pages is a array of pages that will show in popover.
   * @param {object} i18n .
   *
   * @return {Void} void
   */
  initialize({
    pages,
    i18n,
    handlePaginationExternally = false,
  }) {
    this.pages = pages;
    this.i18n = i18n;
    this.handlePaginationExternally = handlePaginationExternally;
  }
  get template() {
    return ({ model }) => pagedContentTemplate({
      model,
      pages: this.pages,
    });
  }
  get events() {
    return {
      'click .popover-paged-content__pager .grid-previous': 'pagePre',
      'click .popover-paged-content__pager .grid-next': 'pageNext',
    };
  }
  /**
   * Set the index of current page in pages array
   * @param {int} currentPage set the index of current page in pages array as currentPage.
   * @returns {PagedContent} - The view itself
   */
  setPages(currentPage) {
    this.currentPage = currentPage;
    const pager = new PagerView({ i18n: this.i18n }).setPager({
      currentPage,
      pageSize: this.pages.length,
    });

    this.setChild('pagination', pager);
    return this.setState({
      currentPage,
    });
  }
  /**
   * Get to the previous page
   * @param {object} event - event passed in to event handler
   * @returns {void}
   */
  pagePre(event) {
    if (this.handlePaginationExternally) {
      this.trigger('willPageUpdate', this.currentPage - 1);
    } else {
      this.setPages(this.currentPage - 1);
    }
    event.stopPropagation();
  }
  /**
   * Get to the next page
   * @param {object} event - event passed in to event handler
   * @returns {void}
   */
  pageNext(event) {
    if (this.handlePaginationExternally) {
      this.trigger('willPageUpdate', this.currentPage + 1);
    } else {
      this.setPages(this.currentPage + 1);
    }
    event.stopPropagation();
  }
}
